// extracted by mini-css-extract-plugin
export default {"timeline":"timeline__1ud4J"};
    if(module.hot) {
      // 1792668416716
      var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  